// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"bf97d23b","453":"f19848d3"}[chunkId] + ".chunk.js";
};